import styles from './AsideBar.module.scss';
import SvgIcon from '../../../assets/icons';
import { Button } from '../../form/Button';
import cn from 'classnames';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { setUser } from '../../../store/userSlice';
import { AUTH_TOKEN, COCKTAILS_PAGE, HOME_PAGE, profileNavigation } from '../../../lib/constans';
import useCookie from '../../../lib/hooks/useCookie';
import { useState } from 'react';

const AsideBar = ({ isOpenMenu, logOut }: { isOpenMenu: boolean; logOut: () => void }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { deleteCookie } = useCookie();

  const logoutUser = () => {
    setIsLoading(true);
    deleteCookie(AUTH_TOKEN);
    dispatch(setUser(null));
    navigate(HOME_PAGE);
    logOut();
    setIsLoading(false);
  };

  return (
    <nav className={cn(styles.aside, { [styles.aside_isOpen]: isOpenMenu })}>
      <div className={styles.aside__inner}>
        <div className={styles.aside__navigation}>
          <div className={styles.aside__logo}>
            <SvgIcon name="logo" width="120" height="20" />
          </div>

          {profileNavigation.map(item => {
            return (
              <Link to={item.link} key={item.id}>
                <div
                  className={cn(styles.aside__navItem, {
                    [styles.aside__navItem_isActive]:
                      location.pathname === item.link ||
                      (location.pathname === HOME_PAGE && item.link === COCKTAILS_PAGE),
                  })}
                >
                  <div>{item.icon}</div>
                  <div className={styles.aside__item}>{item.title}</div>
                </div>
              </Link>
            );
          })}
        </div>

        <Button label="Log out" onClick={logoutUser} loading={isLoading} />
      </div>
    </nav>
  );
};

export default AsideBar;
